// extracted by mini-css-extract-plugin
export var legendIndicator = "_d1-1";
export var legendRight = "_d1-0";